// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__34-z6","receiptsFirstBlock":"styles_receiptsFirstBlock__3FAvs","receiptsFirstItems":"styles_receiptsFirstItems__K5OGZ"};